export const payslipsConstants = {
  GET_REQUEST: 'PAYSLIPS_GET_REQUEST',
  GET_SUCCESS: 'PAYSLIPS_GET_SUCCESS',
  GET_FAILURE: 'PAYSLIPS_GET_FAILURE',
};
